import { DeleteOp } from './ops';

/**
 * Tests if the passed value is an delete operation.
 * @param val The value to check.
 */
export default (val: unknown): val is DeleteOp =>
  val && typeof (val as any).delete === 'string';
